import Vue from "vue";
import { API } from "aws-amplify";
import { bodyWithAuthHeader, handleHttpError } from "../utils/utils";

const locService = Vue.prototype.$localizationService;

const API_PATH = "/assignments";

export default {
  name: "assignmentModule",
  namespaced: true,

  state: {
    activeAssignments: [],
    returnedAssignments: [],
    activeTotal: 0,
    returnedTotal: 0,
    loading: false,
  },

  mutations: {
    setActiveAssignments(state, { items, total }) {
      state.activeAssignments = items;
      state.activeTotal = total;
    },

    setReturnedAssignments(state, { items, total }) {
      state.returnedAssignments = items;
      state.returnedTotal = total;
    },

    setLoading(state, loading) {
      state.loading = loading;
    },
  },

  actions: {
    async loadActiveAssignments({ commit }, {
      driverId, page = 0, size = 20, sort = [],
    }) {
      commit("setLoading", true);

      const queryParams = {
        page,
        size,
      };

      if (sort && sort.length > 0) {
        queryParams.sort = sort.join(",");
      }

      const body = {
        ...await bodyWithAuthHeader(),
        queryStringParameters: queryParams,
      };

      try {
        const response = await API.get("core", `${API_PATH}/driver/${driverId}/active`, body);
        commit("setActiveAssignments", { items: response.items, total: response.total });
      } catch (e) {
        handleHttpError(e);
      } finally {
        commit("setLoading", false);
      }
    },

    async loadReturnedAssignments({ commit }, {
      driverId, page = 0, size = 20, sort = [],
    }) {
      commit("setLoading", true);

      const queryParams = {
        page,
        size,
      };

      if (sort && sort.length > 0) {
        queryParams.sort = sort.join(",");
      }

      const body = {
        ...await bodyWithAuthHeader(),
        queryStringParameters: queryParams,
      };

      try {
        const response = await API.get("core", `${API_PATH}/driver/${driverId}/returned`, body);
        commit("setReturnedAssignments", { items: response.items, total: response.total });
      } catch (e) {
        handleHttpError(e);
      } finally {
        commit("setLoading", false);
      }
    },

    async createAssignment({ dispatch }, {
      driverId, inventoryId, quantity, dateIssued, notes,
    }) {
      const body = {
        ...await bodyWithAuthHeader(),
        body: {
          driverId,
          inventoryId,
          quantity,
          dateIssued,
          notes,
        },
      };

      try {
        await API.post("core", API_PATH, body);
        // Reload active assignments after creating
        await dispatch("loadActiveAssignments", { driverId });
        return locService.localize("store.assignment.create_success");
      } catch (e) {
        throw new Error(e.response?.data?.message || "Failed to create assignment");
      }
    },

    async returnAssignment({ dispatch }, {
      assignmentId, driverId, dateReturned, quantity, returnToInventory, notes,
    }) {
      const body = {
        ...await bodyWithAuthHeader(),
        body: {
          dateReturned,
          quantity,
          returnToInventory,
          notes,
        },
      };

      try {
        await API.put("core", `${API_PATH}/${assignmentId}`, body);
        // Reload both active and returned assignments
        await Promise.all([
          dispatch("loadActiveAssignments", { driverId }),
          dispatch("loadReturnedAssignments", { driverId }),
        ]);
        return locService.localize("store.assignment.return_success");
      } catch (e) {
        throw new Error(e.response?.data?.message || "Failed to return assignment");
      }
    },
  },
};
